import { ROLE } from '../staticRoleManagement/types'

const ROLE_BY_UPPER_CASE = new Map<string, ROLE>(
  Object.values(ROLE).map((role) => [role.toUpperCase(), role])
)

/**
 * IAM names roles 'Channel', 'Channel_Admin', 'Accommodation', …; the ROLE enum spells them
 * 'CHANNEL', 'CHANNEL_ADMIN', 'ACCOMMODATION', … (only 'Admin' agrees). Every
 * rolesListWith…Access check compares with includes(), so an unmapped role matched nothing:
 * channel users got the inventory page with no hotel picker and no table. Returns the enum's
 * spelling for a role that matches ignoring case, and the input unchanged otherwise.
 */
export const canonicalRole = (role: string | undefined): ROLE | undefined => {
  if (!role) return undefined

  return ROLE_BY_UPPER_CASE.get(role.toUpperCase()) ?? (role as ROLE)
}
